<template>
  <div>
    <template>
      <Poptip placement="bottom" width="400" ref="poptipModal">
        <span :style="{ color: this.text === '上架' ? '#52c41a' : '#999999' }"> {{ text }} </span>
        <template #content>
          <div class="modal_content">
            <div class="unitPrice">
              是否上架：
              <Select v-model="requisitiontext" style="width: 200px" @on-change="Onchange(requisitiontext)">
                <Option v-for="item in List" :value="item.label" :key="item.value">{{
                  item.label
                }}</Option>
              </Select>
            </div>
            <div class="modal_content_btn">
              <Button type="primary" class="modal_content_btn_ok" @click="onModalSubmit">确定</Button>
            </div>
          </div>
        </template>
      </Poptip>
    </template>
  </div>
</template>

<script>
export default {
  props: ["text", "item"],
  data() {
    return {
      requisitiontext: "",
      List: [
        { label: "上架", value: 1 },
        { label: "下架", value: 2 },
      ],
    };
  },
  created() {
    this.requisitiontext = this.text
  },
  methods: {
    Onchange(value) {
      const text = this.List.find((item) => item.value === value);
      if (text) {
        this.requisitiontext = text.label;
      }
    },
    async onModalSubmit() {
      let q = {};
      if (!this.requisitiontext) {
        $utils.toast.success("请选择是否上架！");
        return;
      }
      if (this.requisitiontext == "下架") {
        q.isshow = 2;
      } else {
        q.isshow = 1;
      }
      q.id = this.item.id;
      let res = await $utils.api.load("/admin/system/inventory", q, "PUT");
      if (res.code == 200) {
        this.$refs.poptipModal.handleClose();
        $utils.toast.success("修改成功！下架后手机端将不再展示");
        this.$emit("reset");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.modal_content {
  padding: 20px;

  .unitPrice {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
  }

  .modal_content_btn {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
